
import Vue from "vue";

export default Vue.extend({
  name: "Resolves",
  data: () => {
    return {
      radio: null,
      radioGroup: [
        "Office mailed cheque",
        "Office did e-transfer",
        "Hygienists said they got it",
        "Other"
      ]
    };
  },
  methods: {
    updateValue(value: string): void {
      this.$emit("input", value);
    },
    changeNote(): void {
      if (this.radio === "Other") {
        this.$emit("input", "");
      } else {
        this.$emit("input", this.radio);
      }
    }
  }
});
